export const resourcePlatforms = [
  {
    name: "Standalone VR",
    key: "standalonevr",
    file: null,
    url: null,
    comment: "",
    assetType: "ab",
    embedLink: null,
    progress: 0,
    error: null,
  },
  {
    name: "Mobile",
    key: "mobile",
    file: null,
    url: null,
    comment: "",
    assetType: "ab",
    embedLink: null,
    progress: 0,
    error: null,
  },
  {
    name: "Desktop VR",
    key: "desktopvr",
    file: null,
    url: null,
    comment: "",
    assetType: "ab",
    embedLink: null,
    progress: 0,
    error: null,
  },
  {
    name: "Desktop",
    key: "desktop",
    file: null,
    url: null,
    comment: "",
    assetType: "ab",
    embedLink: null,
    progress: 0,
    error: null,
  },
  {
    name: "WebGL",
    key: "web",
    file: null,
    url: null,
    comment: "",
    assetType: "ab",
    embedLink: null,
    progress: 0,
    error: null,
  },
  {
    name: "iOS",
    key: "iOS",
    file: null,
    url: null,
    comment: "",
    assetType: "ab",
    embedLink: null,
    progress: 0,
    error: null,
  },
  {
    name: "Nolo",
    key: "nolo",
    file: null,
    url: null,
    comment: "",
    assetType: "ab",
    embedLink: null,
    progress: 0,
    error: null,
  },
];

export const assestType = [
  // { name: "Asset Bundles", key: "ab" },
  { name: "EXE File", key: "exe" },
];
